import "/src/background.css"
import React from 'react';


const BackgroundContainer = () => {
    return (
      <div className="background-container">
        <div className="stars"></div>
        <div className="twinkling"></div>
        <div className="clouds"></div>

        
      </div>
    );
  };
  
  export default BackgroundContainer;